import { render, staticRenderFns } from "./PovertyAlleviation.vue?vue&type=template&id=13d6f548&scoped=true&"
import script from "./PovertyAlleviation.vue?vue&type=script&lang=js&"
export * from "./PovertyAlleviation.vue?vue&type=script&lang=js&"
import style0 from "./PovertyAlleviation.vue?vue&type=style&index=0&id=13d6f548&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d6f548",
  null
  
)

export default component.exports